/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeALeftIcon24Solid = forwardRef('ArrowShapeALeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.795 13.856a2.625 2.625 0 0 1 0-3.712l8.73-8.73C12.437.502 14 1.149 14 2.44V6h5.75A2.25 2.25 0 0 1 22 8.25v7.5A2.25 2.25 0 0 1 19.75 18H14v3.56c0 1.292-1.562 1.94-2.476 1.026l-8.729-8.73Z" })));
});
